import { createSlice } from '@reduxjs/toolkit'

const initialState = {
 
  selectedOutlet : 0
}

export const outletSlice = createSlice({
  name: 'outlet',
  initialState,
  reducers: {
    
    
    updateOutletId: (state, action) => {
      state.selectedOutlet = action.payload;
    },
  },
})

// Action creators are generated for each case reducer function
export const { updateOutletId } = outletSlice.actions

export default outletSlice.reducer